import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SignInRPC } from "./signInRPC";

export class SignInRPCClientImpl extends SignInRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SignInRPC.Request): Promise<LeoRPCResult<SignInRPC.Response, SignInRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "auth/SignIn",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SignInRPC.ResponseDTO,
      SignInRPC.Errors.ErrorsDTO,
      SignInRPC.Response,
      SignInRPC.Errors.Errors
    >(
      response,
      "auth/SignIn",
      SignInRPC.Response.fromDTO,
      SignInRPC.Errors.fromDTO
    );
  }
}
